import React from 'react'
import PropTypes from 'prop-types'

import Image from './image'
import { EpisodeSelectorUiConsumer } from '../episode-selector-ui'
import { IMAGE_WIDTH } from '../constants'
import EpisodeInfo from './episode-info'

const baseStyles = {
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    opacity: 0.5,
    transform: 'scale(1)',
    minHeight: 254,
    paddingTop: 15,
    transition: 'opacity 200ms ease-out, transform 200ms ease-out',
    paddingLeft: 24,
    paddingRight: 0
  },
  active: {
    zIndex: 1,
    opacity: 1,
    transform: 'scale(1.1)',
    transitionDuration: '100ms'
  },
  current: {
    zIndex: 0
  },
  link: {
    position: 'relative',
    width: IMAGE_WIDTH
  },
  name: {
    margin: '4px 10px 0 10px',
    maxWidth: '100%',
    height: 'auto',
    color: '#fff'
  }
}

class Episode extends React.PureComponent {
  render() {
    const {
      episode, active, forwardRef
    } = this.props

    const wrapperStyle = {
      ...baseStyles.wrapper,
      ...(episode.isCurrentEpisode ? baseStyles.current : {}),
      ...(active ? baseStyles.active : {})
    }
    const imageUri = episode.images.uri

    return (
      <EpisodeSelectorUiConsumer>
        {({ onImageryLoaded, onImageryError, setActiveEpisode }) => {
          return (
            <div
              ref={forwardRef}
              onMouseEnter={() => {
                setActiveEpisode(episode.episodeNumber)
              }}
              style={wrapperStyle}
            >
              <div style={baseStyles.link}>
                <EpisodeInfo episode={episode} />
                <Image
                  onLoad={() => onImageryLoaded(episode.seasonNumber)}
                  onLoadError={() => onImageryError(episode.seasonNumber)}
                  src={imageUri}
                  isPrimaryColorBorder={episode.isCurrentEpisode}
                  isBorderShown={active}
                />
                <div style={baseStyles.name}>
                  {episode.episodeNumber}
                  .
                  {' '}
                  {episode.name}
                </div>
              </div>
            </div>
          )
        }}
      </EpisodeSelectorUiConsumer>
    )
  }
}

Episode.propTypes = {
  episode: PropTypes.shape({
    images: PropTypes.shape({
      uri: PropTypes.string.isRequired
    }).isRequired,
    name: PropTypes.string.isRequired,
    episodeNumber: PropTypes.string.isRequired,
    isCurrentEpisode: PropTypes.bool.isRequired,
    seasonNumber: PropTypes.string.isRequired
  }).isRequired,
  active: PropTypes.bool.isRequired,
  forwardRef: PropTypes.shape({
    current: PropTypes.oneOfType([PropTypes.any])
  })
}

Episode.defaultProps = {
  forwardRef: undefined
}

export default Episode
